module.exports = __webpack_public_path__ + "static/media/11.a6b84b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/11.png
// module id = 792
// module chunks = 0